// src/config/tracking.ts
import { env } from '@/utils/env'

export const trackingConfig = {
  gtm: {
    containerId: import.meta.env.VITE_GTM_CONTAINER_ID,
  },
  googleAds: {
    convertion: import.meta.env.VITE_GADS_CONVERTION_ID,
  },
  googleAnalytics: {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
  },
  facebookPixel: {
    id: import.meta.env.VITE_FB_PIXEL_ID,
  },
  // Enable tracking only in staging or prod
  isEnabled: env.isProd || env.isStaging,
} as const
